import { motion } from 'framer-motion';

export const Reveal = ({ children, delay = 0, className = '', y = 32, ...rest }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: '-80px' }}
    transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
    className={className}
    {...rest}
  >
    {children}
  </motion.div>
);

export const Kicker = ({ children }) => (
  <p className="text-xs font-semibold tracking-[0.18em] uppercase text-eco-gold">
    {children}
  </p>
);
